
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/readonly/index.md?watch=parent';
    export const toc = [{"id":"基础组件","depth":2,"title":"基础组件"},{"id":"自定义组件","depth":2,"title":"自定义组件"}];
export const frontmatter = {"title":"只读模式","toc":"menu","filename":"pages/pages/reference/readonly/index.md","lastUpdated":1773900960000};